import { Container, Image, isWeb, XStack } from '@mythical/ui'
import { RenderBlocks } from 'app/components/blocks/RenderBlocks'
import { ButtonLink } from 'app/components/primitive/Button'
import { Meta } from 'app/components/primitive/Meta'
import Spinner from 'app/components/primitive/Spinner'
import MainLayout from 'app/components/structure/Layout/MainLayout'
import Section from 'app/components/structure/Section'
import SectionIntro from 'app/components/structure/SectionIntro'
import { createParam } from 'solito'
import useQuery from 'app/hooks/use-query'
import { createCollectiblePageQuery } from 'app/queries/collectibles/single'
import { useStores } from 'app/store'
import { isIOS } from 'app/utils/constants'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'

const query = createCollectiblePageQuery()
const { useParam } = createParam<{ slug: string }>()

interface CollectibleScreenProps {
  slug: string
}

export const CollectibleScreen = observer<CollectibleScreenProps>((props) => {
  const { userStore } = useStores()
  const [slug] = useParam('slug')
  const [params, setParams] = useState({ slug: props.slug || slug })

  useEffect(() => {
    setParams({ slug })
  }, [slug])

  const { loading, data } = useQuery(query.query, params, query.mapToPage, {
    refetchOnMount: 'always',
    staleTime: 0,
  })

  const { title, quarter, pageContent, terms, heroImage } = data || {}
  const isEligible = userStore?.user?.tier !== '3rd Degree'
  return (
    <MainLayout
      noFooter
      noBottomTabs
      showBackBtn
      contentStyles={{
        borderWidth: 1,
        borderColor: '$primary10',
        bg: '$secondary10',
      }}
    >
      {title && (
        <SectionIntro
          title={title}
          description={quarter}
          pb="$4"
          headingProps={{
            pt: '$4',
          }}
        />
      )}
      {title && <Meta title={title} type="collectible" slug={slug} />}
      <Section paddedX bg="$secondary10" ai="center" space="$5" spaciousBottom>
        {loading && <Spinner pt="$3" size="large" />}
        {heroImage && (
          <Container
            mediumLarge
            overflow="hidden"
            borderRadius="$3"
            {...(isWeb ? { pb: '56.25%' } : { aspectRatio: 16 / 9 })}
          >
            <Image
              source={{ uri: heroImage }}
              width="100%"
              height="100%"
              pos={isWeb ? 'absolute' : 'relative'}
            />
          </Container>
        )}
        {pageContent && (
          <Container mediumLarge>
            <RenderBlocks
              blocks={pageContent}
              slug={slug}
              textProps={{
                textAlign: 'center',
                size: '$5',
              }}
              spaced
            />
          </Container>
        )}
        {!isIOS && isEligible && (
          <XStack flexWrap="wrap" jc="center">
            <ButtonLink m="$2" href="/perks">
              Join 3rd Degree Quarterly
            </ButtonLink>
            <ButtonLink m="$2" href="/perks">
              Join 3rd Degree Annual
            </ButtonLink>
          </XStack>
        )}
        {terms && (
          <Container mediumLarge>
            <RenderBlocks
              blocks={terms}
              textProps={{
                textAlign: 'center',
                size: '$3',
                fontWeight: '300',
              }}
              spaced
            />
          </Container>
        )}
      </Section>
    </MainLayout>
  )
})
